<script lang="ts" setup>
import { BreadcrumbsProps } from "~/components/Utils/Breadcrumbs.props"
import { ListPostsProps } from "~/components/Grid/ListPosts.props"
import { customPaths } from "~/utils/constants"
import { SeoBaseProps } from "~/components/seo/Base.props"
import { removePageFromUrl, removeParamsAndAnchors } from "~/utils/url"

const { locale } = useI18n()
const route = useRoute()

const posts: ListPostsProps = reactive({
  title: "",
  postsList: [],
  totalPosts: 0
})

const { data: pageData, error: pageError } = await usePage(
  `/api/gluon/fetchTopMagazineCategoryPage/${locale.value}/${
    route.params.category as string
  }/top_magazine_category.js`,
  {
    method: "GET"
  }
)

const multiplySequence = (x: number) => {
  const pageBefore = x - 1
  return pageBefore * 12
}

const currentPage = computed(() =>
  route.params.page
    ? multiplySequence(parseInt(route.params.page as string))
    : 0
)

const { data: getCategoryPosts, error: errorGetCategoryPosts } = await useFetch(
  `/api/magazine/getPostsCategoryPagination/${currentPage.value}/12/${pageData.value?.category?.slug}`,
  {
    method: "GET"
  }
)

if (errorGetCategoryPosts.value) {
  console.warn("error get category of Magazine", errorGetCategoryPosts.value)
  await navigateTo(`${removeParamsAndAnchors(removePageFromUrl(route.path))}`, {
    redirectCode: 302
  })
} else {
  posts.title = getCategoryPosts?.value?.title ?? ""
  posts.postsList = getCategoryPosts?.value?.posts ?? []
  posts.totalPosts = getCategoryPosts?.value?.total ?? 0
}

const breadcrumbs: ComputedRef<BreadcrumbsProps> = computed(() => ({
  links: [
    {
      label: "Home",
      to: "/"
    },
    {
      label: "Top Magazine",
      to: customPaths.magazineRoot
    }
  ],
  currentPage: posts?.title
}))

const seoData = computed((): SeoBaseProps => {
  return {
    ...pageData.value?.seo,
    metaTitle:
      `${pageData.value?.seo.metaTitle} - Pagina ${route.params.page}` ??
      undefined,
    metaDescription:
      `${pageData.value?.seo.metaDescription} - Pagina ${route.params.page}` ??
      undefined
  }
})
</script>

<template>
  <div class="all-posts-of-category">
    <SeoBase v-if="seoData" v-bind="seoData" />
    <PagesPosts
      :breadcrumbsLinks="breadcrumbs"
      :postsList="posts"
      :hasDropdownCategory="false"
    />
  </div>
</template>
